import { DataBlock } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import LifeSketchMoreLess from '../helpers/LifeSketchMoreLess'
import ActionButton from '../helpers/ActionButton'
import DetailHeader from '../helpers/DetailHeader'
import HiddenDetails from '../helpers/HiddenDetails'

export default function LifeSketch({
  actionButtonOnClick,
  person,
  toggleShowItemHiddenDetails,
  toggleShowMoreLessLifeSketch,
  setLifeSketchExpandedHeight,
}) {
  const { t } = useTranslation()
  const lifesketchConclusion = person.lifesketch.value
  const lifesketchText = lifesketchConclusion?.value?.value
  const showHiddenDetails = person.lifesketch.showHiddenDetails
  const actionButtonType = person.lifesketch.actionButtonType

  const toggleShowItemHiddenDetailsLifeSketch = () => {
    toggleShowItemHiddenDetails({ item: 'LifeSketch' })
  }
  const actionButtonOnClickLifeSketch = () => {
    actionButtonOnClick({ item: 'LifeSketch', actionButtonType })
  }

  return (
    <>
      <DataBlock
        heading={
          <DetailHeader
            heading={t('person.fact.lifeSketch', 'Life Sketch')}
            showHiddenDetails={showHiddenDetails}
            toggleShowItemHiddenDetails={toggleShowItemHiddenDetailsLifeSketch}
          />
        }
        data={
          <LifeSketchMoreLess
            showMore={person.lifesketch.showMore}
            onMoreLessClick={toggleShowMoreLessLifeSketch}
            collapsedLineCount={1}
            externalChildHeight={
              person.lifesketch.expandedHeight > person.lifesketch.otherExpandedHeight
                ? person.lifesketch.expandedHeight
                : person.lifesketch.otherExpandedHeight
            }
            setLifeSketchExpandedHeight={setLifeSketchExpandedHeight}
            isSurvivingPerson={person.isSurvivingPerson}
            originalChildHeight={person.lifesketch.expandedHeight}
          >
            {lifesketchText}
          </LifeSketchMoreLess>
        }
      />
      <HiddenDetails person={person} conclusion={lifesketchConclusion} showHiddenDetails={showHiddenDetails} />
      <ActionButton type={actionButtonType} onClick={actionButtonOnClickLifeSketch} />
    </>
  )
}
